var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHhNotifySquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-opacity:0}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#2696be}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.7,360H19.98c-11.21,0-20.3-9.09-20.3-20.3V20.67c0-11.21,9.09-20.3,20.3-20.3H339.7 c11.21,0,20.3,9.09,20.3,20.3V339.7C360,350.91,350.91,360,339.7,360z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.49,158.68l-11.84-14.23c-0.73-0.88-0.61-2.2,0.27-2.93L178.8,38.02c0.88-0.73,2.2-0.61,2.93,0.27 l11.84,14.23c0.73,0.88,0.61,2.2-0.27,2.93L68.43,158.96C67.54,159.69,66.22,159.56,65.49,158.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.65,41.07l-9.01,7.5c-2.02,2.43-1.68,6.07,0.75,8.08l119.76,98.83c2.43,2.02,6.08,1.68,8.1-0.75 l7.15-8.6c2.02-2.43,1.68-6.07-0.75-8.08L182.74,40.33C180.31,38.31,176.67,38.65,174.65,41.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.27,201.47v18.8c0,1.06-0.87,1.93-1.93,1.93H84.86c-1.06,0-1.93-0.87-1.93-1.93v-18.8 c0-1.06,0.87-1.93,1.93-1.93h75.49C161.41,199.54,162.27,200.41,162.27,201.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.46,201.47v18.8c0,1.06-0.87,1.93-1.93,1.93h-75.49c-1.06,0-1.93-0.87-1.93-1.93v-18.8 c0-1.06,0.87-1.93,1.93-1.93h75.49C273.59,199.54,274.46,200.41,274.46,201.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.08,280.73h-18.84c-1.06,0-1.93-0.87-1.93-1.93V134.16c0-1.06,0.87-1.93,1.93-1.93h18.84 c1.06,0,1.93,0.87,1.93,1.93V278.8C282.01,279.86,281.15,280.73,280.08,280.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.82,280.73h-18.84c-1.06,0-1.93-0.87-1.93-1.93V134.16c0-1.06,0.87-1.93,1.93-1.93h18.84 c1.06,0,1.93,0.87,1.93,1.93V278.8C212.75,279.86,211.88,280.73,210.82,280.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.92,280.73h-18.84c-1.06,0-1.93-0.87-1.93-1.93V134.16c0-1.06,0.87-1.93,1.93-1.93h18.84 c1.06,0,1.93,0.87,1.93,1.93V278.8C170.85,279.86,169.98,280.73,168.92,280.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.49,280.73H79.65c-1.06,0-1.93-0.87-1.93-1.93V134.16c0-1.06,0.87-1.93,1.93-1.93h18.84 c1.06,0,1.93,0.87,1.93,1.93l0,144.64C100.42,279.86,99.55,280.73,98.49,280.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.33,113.42h-23.26c-1.31,0-2.38-1.07-2.38-2.38V77.02c0-1.31,1.07-2.38,2.38-2.38h23.26 c1.31,0,2.38,1.07,2.38,2.38v34.01C267.72,112.35,266.64,113.42,265.33,113.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "178.7,62.37 83.11,141.38 270.97,141.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "97.06,136.91 179.22,67.98 179.02,71.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "280.73,151.91 179.16,66.67 179.02,70.27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.74,
    y: 83.34,
    className: "st0",
    width: 9.69,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.75,
    y: 83.31,
    transform: "matrix(-8.971508e-11 1 -1 -8.971508e-11 278.424 -78.7436)",
    className: "st0",
    width: 9.67,
    height: 33.06
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHhNotifySquare);
export default __webpack_public_path__ + "static/media/HHNotify_square.f0688fef046464f116410f19d91991e8.svg";
export { ForwardRef as ReactComponent };